export const generateFaqSchema = faqs => {
  if (faqs && faqs.length > 0) {
    return [
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map(faq => {
          return {
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer
            }
          };
        })
      }
    ];
  }
  return [];
};
